import React from "react";

const Address = () => {
  return (
    <>
      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-map position-absolute"></i>
        <span className="d-block">Адреса</span>м. Харків, Салтівське шоссе 248
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-envelope-open position-absolute"></i>
        <span className="d-block">Електронна пошта</span>{" "}
        <a href="mailto:main@maguto.tech">main@maguto.tech</a>
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-phone-square position-absolute"></i>
        <span className="d-block">Телефон</span>{" "}
        <a href="tel:+380936447838">+38(093)644-78-38</a>
      </p>
      {/* End .custom-span-contact */}
    </>
  );
};

export default Address;
